var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkCountryflag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 105,
    viewBox: "0 0 150 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4347_23893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79891 104.348H142.201C146.522 104.103 150 100.489 150 96.1141V8.2337C150 3.72283 146.332 0.0271739 141.821 0H8.17935C3.66848 0.0271739 0 3.72283 0 8.2337V96.087C0 100.489 3.47826 104.103 7.79891 104.348Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5109 62.5815V104.348H85.3804V62.5815H150V41.712H85.3804V0H64.5109V41.712H0V62.5815H64.5109Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3359 33.7772V0H141.874C145.298 0.0543478 148.233 2.20109 149.428 5.21739L92.3359 33.7772Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3359 70.5703V104.347H142.2C145.488 104.157 148.26 102.038 149.428 99.1301L92.3359 70.5703Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.554 70.5703V104.347H7.79857C4.51053 104.157 1.71162 102.038 0.570312 99.0757L57.554 70.5703Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.554 33.7772V0H8.12466C4.70075 0.0543478 1.73879 2.22826 0.570312 5.27174L57.554 33.7772Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 34.7826H20.788L0 24.375V34.7826Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.998 34.7823H129.102L149.998 24.3203V34.7823Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.998 69.5654H129.102L149.998 80.0274V69.5654Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 69.5654H20.788L0 79.973V69.5654Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.001 8.83105L98.2344 34.7821H109.81L150.001 14.6734V8.83105Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6576 69.5654H40.0815L0 89.6198V95.4622L51.7663 69.5654H51.6576Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.587 34.8099H40.163L0 14.7012V20.5164L28.587 34.8099Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.275 69.5381H109.699L149.998 89.7283V83.9131L121.275 69.5381Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4347_23893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 104.348,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkCountryflag);
export default __webpack_public_path__ + "static/media/uk_countryflag.d8d03c368b53e5105e3cc3ed13079b27.svg";
export { ForwardRef as ReactComponent };